import InsureProcessCar from './InsureProcessCar';
export default InsureProcessCar;
